<div class="reporting-toolbar">
  <p-selectbutton
    [(ngModel)]="selectedYear"
    [options]="yearOptions"
    optionLabel="label"
    optionValue="value"
    [allowEmpty]="false"
    (onChange)="loadReport()">
  </p-selectbutton>

  <select [(ngModel)]="sortMode" class="form-control toolbar-select">
    <option value="name">Trier : Nom A→Z</option>
    <option value="leaves">Trier : % Congés ↓</option>
    <option value="dol">Trier : % Hors Lux ↓</option>
  </select>

  <p-select
    [(ngModel)]="filterOption"
    [options]="countryOptions"
    optionLabel="label"
    placeholder="Tous les pays"
    [showClear]="true"
    styleClass="toolbar-select">
    <ng-template #item let-country>
      <span class="fi" [ngClass]="'fi-' + country.code" style="margin-right: 6px;"></span>
      {{ country.label }}
    </ng-template>
    <ng-template #selectedItem let-country>
      <span class="fi" [ngClass]="'fi-' + country.code" style="margin-right: 6px;"></span>
      {{ country.label }}
    </ng-template>
  </p-select>
</div>

@if (selectedYear === 2024) {
  <div class="year-warning">
    <i class="material-icons">warning</i>
    <div>
      <strong>ATTENTION : pour 2024, le calcul du solde de congé des ITz n'est pas fiable.</strong>
      Pour cette année, seules ces valeurs sont fiables :
      <ul>
        <li>le nombre de jours prestés hors du Luxembourg</li>
        <li>le quota max de jours hors du Luxembourg</li>
      </ul>
    </div>
  </div>
}

@if (isLoading) {
  @for (row of skeletonRows; track $index) {
    <div class="user-report-card skeleton-card">
      <div class="user-report-header">
        <div class="skel skel-flag"></div>
        <div class="skel skel-name"></div>
        <div class="skel skel-mission"></div>
      </div>
      <div class="user-report-bars">
        @if (selectedYear !== 2024) {
          <div class="bar-row">
            <span class="bar-label">Congés</span>
            <div class="skel skel-bar"></div>
          </div>
        }
        <div class="bar-row">
          <span class="bar-label">Hors Lux</span>
          <div class="skel skel-bar"></div>
        </div>
      </div>
    </div>
  }
} @else {
  @for (item of filteredAndSorted(); track item.user.id) {
    <div class="user-report-card" [ngClass]="'alert-' + alertLevel(item)">
      <div class="user-report-header">
        <span class="fi" [ngClass]="flagClass(item.user.taxResidence)"></span>
        <span class="user-name">{{ item.user.userFirstName }} {{ item.user.userName }}</span>
        @if (alertLevel(item) === 'danger') {
          <i class="material-icons alert-icon danger">warning</i>
        } @else if (alertLevel(item) === 'warning') {
          <i class="material-icons alert-icon warning">warning_amber</i>
        }
        <span class="user-mission">{{ item.user.mission?.label ?? 'Bench' }}</span>
      </div>
      <div class="user-report-bars">
        @if (selectedYear !== 2024) {
          <div class="bar-row">
            <span class="bar-label">Congés</span>
            <progressbar
              [value]="leavesPercent(item)"
              [color]="barColor(leavesPercent(item))"
              [label]="item.takenCount + ' / ' + item.totalBalance + ' j'">
            </progressbar>
          </div>
        }
        <div class="bar-row">
          <span class="bar-label">Hors Lux</span>
          <progressbar
            [value]="dolPercent(item)"
            [color]="barColor(dolPercent(item))"
            [label]="item.dolCount + ' / ' + item.maxDol + ' j'">
          </progressbar>
        </div>
      </div>
    </div>
  }
}
